export const getRoomDisplayText = (room: number) => {
    switch (room) {
        case 1:
            return "kawalerki";
        case 5:
            return `${room} pokoi i więcej`;
        default:
            return `${room} pokoje`;
    }
};
export const getRoomDisplayText = (room: number) => {
    switch (room) {
        case 1:
            return "kawalerki";
        case 5:
            return `${room} pokoi i więcej`;
        default:
            return `${room} pokoje`;
    }
};
